import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts"; // assuming you're using react-apexcharts

const SalesChart = ({ selectedYear, handleYearChange, dashboardData, t }) => {
    const [chartOptions, setChartOptions] = useState({
        series: [
            {
                name: t("tableColumnName.sales"),
                data: [], // initially empty
            }
        ],
        colors: ["#EA5455"],
        chart: {
            type: "bar",
            height: 320,
            stacked: true,
            zoom: {
                enabled: true,
            },
        },
        responsive: [
            {
                breakpoint: 280,
                options: {
                    legend: {
                        position: "bottom",
                        offsetY: 0,
                    },
                },
            },
        ],
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 4,
                borderRadiusApplication: "end",
                borderRadiusWhenStacked: "all",
                columnWidth: "20%",
            },
        },
        dataLabels: {
            enabled: false,
        },
        // yaxis: {
        //   min: -200,
        //   max: 300,
        //   tickAmount: 5,
        // },
        xaxis: {
            categories: [], // initially empty
        },
        legend: { show: false },
        fill: {
            opacity: 1,
        },
    });

    useEffect(() => {
        if (dashboardData?.salePurchaseGraphData) {
            const salePurchaseGraphData = dashboardData.salePurchaseGraphData;

            const salesData = Object.values(salePurchaseGraphData).map(
                (item) => item?.sales || 0
            );
            
            const months = Object.keys(salePurchaseGraphData).map((month) =>
                t(`months.${month.substring(0, 3)}`)
            );

            setChartOptions((prevOptions) => ({
                ...prevOptions,
                series: [
                    {
                        name: t("tableColumnName.sales"),
                        data: salesData,
                    }
                ],
                xaxis: {
                    ...prevOptions.xaxis,
                    categories: months,
                },
            }));
        }
    }, [dashboardData, t]);

    return (
        <div className="card flex-fill">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0">{t("tableColumnName.sales")}
                </h5>
                <div className="graph-sets">
                    <ul className="mb-0">
                        <li>
                            <span>{t("tableColumnName.sales")}</span>
                        </li>
                    </ul>
                    <div className="dropdown dropdown-wraper">
                        <button
                            className="btn btn-light btn-sm dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {selectedYear}
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            {[...Array(new Date().getFullYear() - 2022)].map((_, index) => {
                                const year = new Date().getFullYear() - index;
                                return (
                                    <li key={year}>
                                        <p
                                            className="dropdown-item"
                                            onClick={() => handleYearChange(year)}
                                        >
                                            {year}
                                        </p>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <div id="sales_charts" />
                <Chart
                    options={chartOptions}
                    series={chartOptions.series}
                    type="bar"
                    height={320}
                />
            </div>
        </div>
    );
};

export default SalesChart;
